<template>
	<div class="settings-page">
		<BusinessInformation />
	</div>
</template>

<script setup>
import { onMounted } from 'vue';
import BusinessInformation from '@/components/settings/BusinessInformation.vue';
import { useProjectsStore } from '@/stores/projects';

const projectsStore = useProjectsStore();

onMounted(() => {
	projectsStore.ensureInitialized();
});
</script>

<style scoped>
.settings-page {
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 0;
	background: var(--noc-background);
}
</style>
